import React, { useEffect, useState } from 'react';
import Modal from 'react-modal';
import { AiOutlineCloseCircle } from 'react-icons/ai';
import { GoogleMap, LoadScript, Marker, Polyline, useJsApiLoader } from '@react-google-maps/api';
import { mapStyle } from '../../Sidebar/Mapa/Estilo';
import DestinoIcon from "../../../assets/img/Destino.ico";
import OrigenIcon from "../../../assets/img/Origen.png";
import formatDate from '../../../formatDate';

Modal.setAppElement('#root');

export default function ModalFinalizados({ isOpen, onRequestClose, finalizadoDetails }) {
    const timeRequest = finalizadoDetails?.trips_by_pk?.time_request;
    const defaultLatitude = 19.0589756;
    const defaultLongitude = -98.1811881;
    const originLatitude = finalizadoDetails?.trips_by_pk?.locations?.[0]?.latitude || defaultLatitude;
    const originLongitude = finalizadoDetails?.trips_by_pk?.locations?.[0]?.longitude || defaultLongitude;
    const destinationLatitude = finalizadoDetails?.trips_by_pk?.locations?.[1]?.latitude;
    const destinationLongitude = finalizadoDetails?.trips_by_pk?.locations?.[1]?.longitude;
    const [directions, setDirections] = useState(null);

    const { isLoaded } = useJsApiLoader({
        googleMapsApiKey: process.env.REACT_APP_GOOGLE_MAPS,
        libraries: ['geometry', 'drawing', 'places'],
    })

    useEffect(() => {
        if (originLatitude && originLongitude && destinationLatitude && destinationLongitude) {
            const directionsService = new window.google.maps.DirectionsService();
            const request = {
                origin: { lat: originLatitude, lng: originLongitude },
                destination: { lat: destinationLatitude, lng: destinationLongitude },
                travelMode: 'DRIVING',

            };

            directionsService.route(request, (result, status) => {
                if (status === 'OK') {
                    setDirections(result);
                } else {
                    console.error(`Error al obtener direcciones: ${status}`);
                }
            });
        }
    }, [originLatitude, originLongitude, destinationLatitude, destinationLongitude]);

    const modalMarginStyle = window.innerWidth > 1280 ?
        { marginLeft: 'calc((100% - 20.5rem) / 3)', marginTop: '10rem' }
        : { margin: '0 auto', marginTop: '7.5rem' };

    return (
        <Modal
            className={`bg-gray-100 flex flex-col rounded-lg border-6 w-modal mx-auto h-modal border-orange-500 h-modal-content mb-10`}
            isOpen={isOpen}
            onRequestClose={onRequestClose}
            contentLabel="Example Modal"
            style={{
                overlay: {
                    backgroundColor: '#00000099',
                    overflow: 'auto',
                },
                content: {
                    overflowY: "auto",
                    overflowX: "hidden",
                    ...modalMarginStyle,
                },
            }}
        >
            <div className="grid semi:grid-cols-2 sm:grid-rows-2 semi:grid-rows-1">
                <div className="semi:col-span-1 sm:row-start-2 semi:row-start-1">
                    <div className="h-full">
                        {
                            isLoaded &&
                            <GoogleMap
                                mapContainerStyle={{ height: '100%' }}
                                center={{ lat: originLatitude, lng: originLongitude }}
                                zoom={15}
                                options={{ styles: mapStyle.default }}
                            >
                                {finalizadoDetails?.trips_by_pk?.locations.map((location, index) => (
                                    <Marker
                                        key={index}
                                        position={{ lat: location.latitude, lng: location.longitude }}
                                        icon={{
                                            url: index === 0 ? OrigenIcon : DestinoIcon,
                                            scaledSize: new window.google.maps.Size(80, 80),
                                        }}
                                    />
                                ))}
                                {directions && (
                                    <Polyline
                                        path={directions.routes[0].overview_path}
                                        options={{
                                            strokeColor: '#FFF000',
                                            strokeOpacity: 0.8,
                                            strokeWeight: 5,
                                        }}
                                    />
                                )}
                            </GoogleMap>
                        }
                    </div>
                </div>

                <div className="col-span-1 justify-center">
                    <div className='flex items-start semi:justify-between sm:justify-between'>
                        <h2 className="text-xl semi:text-left sm:items-center font-mono ml-2">Detalles del viaje</h2>
                        <button onClick={onRequestClose}>
                            <AiOutlineCloseCircle className="text-orange-500 hover:bg-orange-600  hover:text-white rounded-full text-4xl" />
                        </button>
                    </div>
                    <div className="grid grid-cols-3 mt-6 text-xl">
                        {timeRequest && (
                            <p className="ml-2 col-span-1">
                                <span className="font-bold">Fecha:</span> {formatDate(timeRequest)}
                            </p>)}
                        {finalizadoDetails?.trips_by_pk?.trip_id && (
                            <p className="ml-2 col-span-2">
                                <span className="font-bold">ID Viaje:</span> {finalizadoDetails.trips_by_pk.trip_id.substring(0, 13)}
                            </p>
                        )}
                    </div>
                    {finalizadoDetails?.trips_by_pk?.driver_id && (
                        <p className="text-xl ml-2 col-span-2 mt-4">
                            <span className="font-bold ">ID conductor:</span> {finalizadoDetails.trips_by_pk.driver_id}
                        </p>
                    )}
                    <div className="grid grid-cols-2 mt-6 text-xl">
                        {finalizadoDetails?.trips_by_pk?.status && (
                            <p className="ml-2 col-span-1">
                                <span className="font-bold">Estatus:</span> {finalizadoDetails.trips_by_pk.status}
                            </p>
                        )}
                        {finalizadoDetails?.trips_by_pk?.substatus && (
                            <p className="ml-2 col-span-1">
                                <span className="font-bold">Sub-estatus:</span> {finalizadoDetails.trips_by_pk.substatus}
                            </p>
                        )}
                    </div>
                    {finalizadoDetails?.trips_by_pk?.reasons_cancellation ? (
                        <p className="text-lg mt-6 ml-2 col-span-1">
                            <span className="font-bold">Nota:</span> {finalizadoDetails.trips_by_pk.reasons_cancellation}
                        </p>
                    ) : (
                        <p className="text-lg mt-6 ml-2 col-span-1">
                            <span className="font-bold">Nota:</span> Sin comentarios
                        </p>
                    )}
                    <div className="grid grid-cols-2 mt-6 text-xl">
                        {finalizadoDetails?.trips_by_pk?.payment_method && (
                            <p className="ml-2 col-span-1">
                                <span className="font-bold">Metodo de Pago:</span> {finalizadoDetails.trips_by_pk.payment_method}
                            </p>
                        )}
                        {finalizadoDetails?.trips_by_pk?.costo && (
                            <p className="ml-2 col-span-1">
                                <span className="font-bold">Costo:</span> {finalizadoDetails.trips_by_pk.costo}
                            </p>
                        )}
                    </div>
                    {finalizadoDetails?.trips_by_pk?.locations[0]?.description && (
                        <p className="text-xl ml-2 mt-6">
                            <span className="font-bold">Origen:</span> {finalizadoDetails.trips_by_pk.locations[0].description}
                        </p>
                    )}
                    {finalizadoDetails?.trips_by_pk?.locations[1]?.description && (
                        <p className="text-xl ml-2 mt-6">
                            <span className="font-bold">Destino:</span> {finalizadoDetails.trips_by_pk.locations[1].description}
                        </p>
                    )}
                    {finalizadoDetails?.trips_by_pk?.user_data.name && (
                        <p className="text-xl ml-2 mt-6 col-span-1">
                            <span className="font-bold">Usuario:</span> {finalizadoDetails.trips_by_pk.user_data.name || 'N/A'} {finalizadoDetails.trips_by_pk.user_data.last_name || 'N/A'}
                        </p>
                    )}
                    {finalizadoDetails?.trips_by_pk?.user_id && (
                        <p className="text-xl ml-2 mt-4 col-span-1">
                            <span className="font-bold">ID Usuario:</span> {finalizadoDetails.trips_by_pk.user_id}
                        </p>
                    )}
                </div>
            </div>
        </Modal>
    );
}